<h4 class="section-heading">Select a start date to run your promo</h4>
@if (context === 'SOLDOUT') {
  <p>
    The dates you chose for your promostack are now soldout. Please pick a new set of dates below. We're sorry for the inconenience.
  </p>
}
<div class="date-container">
  <ul class="date-list">
    @for (item of promoStackAvailability; track item) {
      <li
        [class]="{ 'selected': item.pubDate === selectedDate, 'soldout': item.soldout, 'member-exclusive': item.memberExclusive }"
        (click)="selectDate(item.pubDate, item.soldout, item.memberExclusive)">
        <span class="date-day">{{item.day}}</span>
        @if (item.memberExclusive) {
          <span class="member-tag">Gold &amp; Platinum only</span>
        }
        <span class="date-value">{{item.date}}</span>
      </li>
    }
  </ul>
</div>
@if (releaseSchedule?.length) {
  <div>
    <h4 class="section-heading">Your Promo Stack dates</h4>
    <ul class="release-schedule-list">
      @for (item of releaseSchedule; track item) {
        <li class="release-schedule">
          <div class="row">
            <div class="md-5">{{item.name}}</div>
            <div class="md-5">{{item.advert}}</div>
            <div class="md-2">{{item.date}}</div>
          </div>
        </li>
      }
    </ul>
  </div>
}
